import { OpenCustomerInstructionData } from "./OpenCustomerInstructionForm.schema";

/**
 * Flatten OpenCustomerInstructionData into the PDF AcroForm field names
 * expected by capOpenDoc.pdf.
 */
export function flattenOpenCustomerInstruction(
  data: OpenCustomerInstructionData
): Record<string, unknown> {
  return {
    header: data.header,
    main: data.main,
  };
}
